<template>
  <div>
    <button
      class="filterItem"
      v-for="tag in tags"
      :key="tag.id"
      v-on:click="clearTag(tag)"
    >
      {{tag.title}}
    </button>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { TaxonomyTag } from '../client/src/models/index';

export default Vue.extend({
  name: "ChosenTags",
  props: {
    tags: {
      type: Array as () => TaxonomyTag[],
      required: true,
      default: () => []
    }
  },
  methods: {
    clearTag: function (tag: TaxonomyTag) {
      this.$emit("clearTag", tag);
    }
  }
});
</script>
